// extracted by mini-css-extract-plugin
module.exports = {"M":"mission_M__3uAVT","Mission":"mission_Mission__1tajY","Icons":"mission_Icons__2dL6L","Text":"mission_Text__2BIM4"};